module.exports = __webpack_public_path__ + "img/ic_life_pet.5fbc760b.png";